import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const SoldSectorButton = () => {
  const { t } = useTranslation();
  const [showTooltip, setShowTooltip] = useState(false);

  return (
      <div className="relative" style={{ display: 'inline-block' }}>
        <button
            id="nextButtonPrice"
            className="select-btn-grey"
            style={{
              background: '#6B7280',
              padding: '8px 16px',
              borderRadius: '20px',
              border: 'none',
              color: 'white',
              cursor: 'not-allowed',
              position: 'relative', // Добавляем для z-index
              zIndex: 1000 // Чтобы кнопка была над стрелкой
            }}
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
        >
          <span>{t("sectorSoldButton")}</span>
        </button>

        {showTooltip && (
            <>
              <div
                  style={{
                    position: 'absolute',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '0',
                    height: '0',
                    borderLeft: '15px solid transparent',
                    borderRight: '15px solid transparent',
                    borderBottom: '15px solid #CC0000',
                    top: 'calc(100% - 8px)', // Поднимаем стрелку, чтобы она заходила на кнопку
                    zIndex: 999 // Стрелка под кнопкой
                  }}
              />
              <div
                  style={{
                    position: 'absolute',
                    top: 'calc(100% + 7px)', // Поднимаем блок текста соответственно
                    left: '50%',
                    transform: 'translateX(-50%)',
                    background: '#CC0000',
                    color: 'white',
                    padding: '15px 20px',
                    borderRadius: '4px',
                    fontSize: '14px',
                    zIndex: 998, // Текст под стрелкой
                    whiteSpace: 'normal',
                    width: '250px',
                    textAlign: 'center',
                    lineHeight: '1.4'
                  }}
              >
                {t("allTicketsInThisSectorsAreSold") || "Все билеты в этом секторе проданы, выберите другой сектор!"}
              </div>
            </>
        )}
      </div>
  );
};

export default SoldSectorButton;